// WebDCS claim entry fields, labelled as in the 2020 Hyundai Claims Processing Manual (Section 8.4).
export const CLAIM_TYPES = ["Warranty", "Campaign", "PDI", "Retail Part", "Rental", "Transportation"];
export const CLAIM_STATUSES = ["draft", "ready", "submitted", "returned"];

export const FIELD_GROUPS = [
  {
    title: "Repair order",
    fields: [
      ["ro_number", "R.O. # (last 6 digits)"],
      ["ro_full", "Dealer RO number"],
      ["line", "RO line #"],
      ["campaign", "Campaign code"],
      ["claim_number", "Claim #"],
      ["vin", "VIN"],
      ["ro_date_in", "Repair Order Date (in) MMDDYYYY"],
      ["ro_date_out", "Repair Order Date (out) MMDDYYYY"],
      ["mileage_in", "Mileage (in)"],
      ["mileage_out", "Mileage (out)"],
    ],
  },
  {
    title: "Coding",
    fields: [
      ["causal_part", "Causal Part #"],
      ["nature_code", "Nature Grp/Code"],
      ["cause_code", "Cause"],
      ["op_code", "Op Code"],
      ["op_hours", "Op Code Hrs"],
      ["op_qty", "Op Code Qty"],
      ["extra_ops", "Additional op codes (code hours; ...)"],
      ["gds_codes", "GDS Test Codes"],
      ["battery_code", "Battery Test Code"],
    ],
  },
  {
    title: "Extras",
    fields: [
      ["sublet_amount", "Sublet Amount"],
      ["sublet_code", "Sublet Code"],
      ["towing", "Towing"],
      ["pa_number", "PA#"],
    ],
  },
];

export const STORY_FIELDS = [
  ["complaint", "Complaint Description"],
  ["cause", "Cause Description"],
  ["correction", "Correction Description"],
  ["additional_comments", "Additional Comments"],
];
